'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import { useState } from 'react'

/* -----------------------------------------------------------------------------
 * useCopy
 * -------------------------------------------------------------------------- */

export type useCopyOptions = {
  copyText?: string
  copiedText?: string
  timeout?: number
}

export type useCopyResult = [() => void, string]

const useCopy = (value: string, options?: useCopyOptions): useCopyResult => {
  const copyText = (options || {}).copyText || 'Copy'
  const copiedText = (options || {}).copiedText || 'Copied'
  const timeout = (options || {}).timeout || 1500

  const [text, setText] = useState<string>(copyText)
  const onCopy = () => {
    navigator.clipboard.writeText(value)
    setText(copiedText)
    setTimeout(() => {
      setText(copyText)
    }, timeout)
  }

  return [onCopy, text]
}

export default useCopy
